import axios, { ENDPOINT } from '../../../utils/httpClient'

export const checkStatus = (reference) => {
    return axios(`${ENDPOINT}/payments/${reference}/status`)
}
